import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageLoaderService } from '../core/page-loader.service';

@Component({
  selector: 'app-election-connection-error',
  imports: [CommonModule],
  templateUrl: './election-connection-error.component.html',
  styleUrl: './election-connection-error.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElectionConnectionErrorComponent implements OnInit {
  constructor(private readonly pageLoaderService: PageLoaderService) {}

  ngOnInit(): void {
    this.pageLoaderService.hide();
  }
}
